
module dg.actions {

    export interface IWidgetStateResolve extends angular.ui.IViewStateResolve {
        widgetTemplateUrl?(...args: any[]): string | ng.IPromise<string>;
        widgetTitle?(...args: any[]): string | ng.IPromise<string>;
        link?(...args: any[]): dg.restfulApi.Link | ng.IPromise<dg.restfulApi.Link>;
        excludeInFilter?(...args: any[]): Array<string>;
        includeInFilter?(...args: any[]): Array<string>;
        queryExecutionStrategy?(...args: any[]): string
    }

    export class WidgetController {

        public widgetTitle: string;
        public widgetId: string;
        public widgetTemplateUrl: string;
        public link: dg.restfulApi.Link;
        public queryResult: any;
        public query: any;
        public loading: any;
        public classes: string;
        public excludeInFilter: Array<string>
        public includeInFilter: Array<string>
        public queryExecutionStrategy: string;
        private strategy: IQueryExecutionStrategy;

        public constructor(
            protected actionService: dg.actions.ActionService,
            public $scope: ng.IScope,
            private navigationService: dg.navigation.NavigationService,
            private queryExecutionStrategyFactory: dg.actions.QueryExecutionStrategyFactory) {


            this.loading = {};
            this.loading.loaded = false;
        }

        public refresh() {
            this.loading.loaded = false;
            
            this.strategy.executeQuery(this.query).then(queryResult => {
                this.setResult(queryResult);
            }, angular.noop);

        }

        $onInit() {
            
        }

        $onChanges(changes) {
            if (changes.link.currentValue) {
                this.strategy = this.queryExecutionStrategyFactory.getStartegy(this.queryExecutionStrategy);
                this.getData();
            }

            //if (changes.queryExecutionStrategy && changes.queryExecutionStrategy.currentValue) {
            //    this.strategy = this.queryExecutionStrategyFactory.getStartegy(this.queryExecutionStrategy);
            //}
        }

        private getData = () => {
            if (this.link.rel == dg.restfulApi.DG_LINK_RELS.query) {

                this.strategy.getQuery(this.link).then(result => {
                    this.query = result;
                    this.refresh();
                }, angular.noop);
            }
            else if (this.link.rel == dg.restfulApi.DG_LINK_RELS.queryResult) {

                this.actionService.getQueryResultFromLink(this.link).then(result => {
                    this.setResult(result);
                }, angular.noop);
            }
            else {
                throw new Error(`Link with rel '${this.link.rel}' is not supported in widgets.`);
            }

           
        }

        private linkHasState(): boolean {
            return Boolean(this.navigationService.getState(this.link));
        }

        dismiss() {
            let parentScope: any = this.$scope.$parent;
            if (angular.isFunction(parentScope.$dismiss)) {
                parentScope.$dismiss();
            }
        }

        setResult(result) {
            this.queryResult = result;
            this.loading.loaded = true;
        }
    }

    angular.module('dg.actions').component('widget', {
        bindings: {
            widgetTitle: '@',
            widgetId: '<?',
            widgetTemplateUrl: '@',
            link: '<',
            classes: '@',
            excludeInFilter: '<',
            includeInFilter: '<',
            queryExecutionStrategy: '<'
        },
        controller: WidgetController,
        templateUrl: ($element, $attrs: any) => {
            let templateType = $attrs.templateType;
            let template = '/digmo/src/actions/widget/plain-widget.html'

            if (templateType) {
                template = '/app/src/' + templateType + '-widget.html';
            }
            return template;
        }
    });
}